import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import "dayjs/locale/uk";
import "dayjs/locale/ru";

dayjs.extend(customParseFormat);

export default dayjs;
